/* ===========================
   CRYSTAL QUIZ – GLOBAL VERSION
   Works for BOTH popup and section
   JSON is fully embedded (no CDN issues)
============================= */

let quizData = {
  "q1": {
    "calm": ["Aquamarine", "Amethyst"],
    "confidence": ["Tiger Eye", "Black Onyx"],
    "protection": ["Black Onyx", "Malachite"],
    "creativity": ["Lapis Lazuli", "Tiger Eye"],
    "luck": ["Imperial Jade"],
    "healing": ["Rose Quartz", "Amethyst"]
  },
  "q2": {
    "relationships": ["Rose Quartz"],
    "career": ["Tiger Eye", "Lapis Lazuli"],
    "peace": ["Aquamarine"],
    "selflove": ["Rose Quartz", "Malachite"],
    "intuition": ["Lapis Lazuli", "Amethyst"],
    "health": ["Imperial Jade", "Black Onyx"]
  },
  "q3": {
    "flow": ["Aquamarine", "Lapis Lazuli"],
    "strength": ["Black Onyx", "Tiger Eye"],
    "glow": ["Rose Quartz", "Amethyst"],
    "power": ["Tiger Eye", "Black Onyx"],
    "mystery": ["Malachite", "Amethyst"],
    "transformation": ["Malachite", "Imperial Jade"]
  }
};

let stoneData = {
  "Black Onyx": {
    "image": "https://cdn.shopify.com/s/files/1/0046/3201/9030/files/shop-by-stone-onyx.jpg?v=1762790400",
    "available": true,
    "productUrl": "/pages/black-onyx-built-for-protection-made-for-you",
    "description": "A stone for quiet strength and grounded presence. It fits someone who moves through pressure with control.",
    "why": "This stone aligns with you because your energy is steady, direct, and impossible to push off center.",
    "element": "Earth"
  },
  "Tiger Eye": {
    "image": "https://cdn.shopify.com/s/files/1/0046/3201/9030/files/shop-by-stone-red-tiger-eye.jpg?v=1762790551",
    "available": true,
    "productUrl": "/pages/tiger-eye-for-the-ones-who-don-t-lose-their-edge",
    "description": "A stone for confidence and focused drive. It fits someone who acts with intention and stays true to their direction.",
    "why": "This stone aligns with you because your energy is firm, decisive, and naturally leadership oriented.",
    "element": "Fire"
  },
  "Lapis Lazuli": {
    "image": "https://cdn.shopify.com/s/files/1/0046/3201/9030/files/shop-by-stone-lapis.jpg?v=1762790376",
    "available": true,
    "productUrl": "/pages/lapis-lazuli-for-leaders-who-think-clearly",
    "description": "A stone for clarity and expressive thought. It fits someone who values honesty and speaks with purpose.",
    "why": "This stone aligns with you because your mind is sharp, your voice is intentional, and your presence is thoughtful.",
    "element": "Air"
  },
  "Amethyst": {
    "image": "https://cdn.shopify.com/s/files/1/0046/3201/9030/files/shop-by-stone-amethyst.jpg?v=1762790442",
    "available": true,
    "productUrl": "/pages/amethyst-calm-enough-to-think-strong-enough-to-act",
    "description": "You stay steady when situations get chaotic.You think clearly even when... ",
    "why": "This stone aligns with you because your inner world is steady and you navigate emotions with awareness.",
    "element": "Air"
  },
  "Malachite": {
    "image": "https://cdn.shopify.com/s/files/1/0046/3201/9030/files/shop-by-stone-malachite.jpg?v=1762790309",
    "available": true,
    "productUrl": "/pages/malachite-built-for-bravery-made-for-growth",
    "description": "A stone for growth and personal evolution. It fits someone who steps into change instead of resisting it.",
    "why": "This stone aligns with you because your energy is honest, dynamic, and ready to move forward.",
    "element": "Earth"
  },
  "Rose Quartz": {
    "image": "https://cdn.shopify.com/s/files/1/0046/3201/9030/files/shop-by-stone-rose-quartz.jpg?v=1762790465",
    "available": true,
    "productUrl": "/pages/rose-quartz-strength-in-kindness-power-in-love",
    "description": "A stone for balanced connection and emotional openness. It fits someone who values sincerity in relationships.",
    "why": "This stone aligns with you because your approach to people is honest, warm, and grounded in real care.",
    "element": "Water"
  },
  "Aquamarine": {
    "image": "https://cdn.shopify.com/s/files/1/0046/3201/9030/files/shop-by-stone-aquamarine.jpg?v=1762790483",
    "available": true,
    "productUrl": "/pages/aquamarine-powerful-clarity-for-those-who-speak-with-calm",
    "description": "A stone for clear thinking and calm momentum. It fits someone who navigates life with steady focus.",
    "why": "This stone aligns with you because your presence is cool, composed, and naturally balanced.",
    "element": "Water"
  },
  "Imperial Jade": {
    "image": "https://cdn.shopify.com/s/files/1/0046/3201/9030/files/shop-by-stone-jade.jpg?v=1762790501",
    "available": true,
    "productUrl": "/pages/imperial-jade-strong-intent-pure-path-lasting-calm",
    "description": "A stone for stability and long term vision. It fits someone who builds their life with intention and consistency.",
    "why": "This stone aligns with you because your energy is patient, strategic, and rooted in self respect.",
    "element": "Earth"
  }
};

/* ===========================
   CORE LOGIC
============================= */

let userAnswers = {};
let userName = "";
let grettingDiv = null;

document.addEventListener("DOMContentLoaded", () => {
  grettingDiv = document.getElementById("quiz-greeting");

  /* Popup handling (won't break section if not present) */
  const modal = document.getElementById('quiz-modal');
  const openBtn = document.getElementById('open-quiz');
  const closeBtn = document.getElementById('close-quiz');

  if (openBtn && modal && closeBtn) {
    openBtn.addEventListener('click', e => {
      e.preventDefault();
      modal.style.display = 'flex';
    });

    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
      setTimeout(resetQuiz, 300);
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        modal.style.display = 'none';
        setTimeout(resetQuiz, 300);
      }
    });
  }

  /* Step Q1 */
  document.querySelectorAll('#step-q1 button').forEach(btn => {
    btn.addEventListener('click', () => {
      userAnswers.q1 = btn.dataset.answer;
      document.getElementById("step-q1").style.display = "none";
      document.getElementById("step-q2").style.display = "block";
    });
  });

  /* Step Q2 */
  document.querySelectorAll('#step-q2 button').forEach(btn => {
    btn.addEventListener('click', () => {
      userAnswers.q2 = btn.dataset.answer;
      document.getElementById("step-q2").style.display = "none";
      document.getElementById("step-q3").style.display = "block";
    });
  });

  /* Step Q3 */
  document.querySelectorAll('#step-q3 button').forEach(btn => {
    btn.addEventListener('click', () => {
       document.querySelector("#quiz-greeting").style.display = "none"; 
      userAnswers.q3 = btn.dataset.answer;
      document.getElementById("step-q3").style.display = "none";
      document.getElementById("final-step").style.display = "block";
    });
  });
});

/* ===========================
   QUIZ FUNCTIONS
============================= */

function startQuiz() {
  const nameInput = document.getElementById("user-name");
  
  userName = nameInput.value.trim();


  if (!userName) {
    userName="Guest";
  }

  if (grettingDiv) {
    document.querySelector(".crystal-quiz-heading").style.display = "none";
document.querySelector(".crystal-quiz-subheading").style.display = "none";
    grettingDiv.innerHTML = `Hello ${userName}`;
  }

  const quizSteps = document.getElementById("quiz-steps");
  if (quizSteps) quizSteps.style.display = "block";

  document.getElementById("step-name").style.display = "none";
  document.getElementById("step-q1").style.display = "block";
}

function showResult() {
  const resultDiv = document.getElementById("quiz-result");
  const stone = calculateTopStone(userAnswers);

  if (!stone || !stoneData[stone]) {
    resultDiv.innerHTML = "<p>Something went wrong. Try again.</p>";
    return;
  }
  document.querySelector("#quiz-greeting").style.display = "none"; 

  const s = stoneData[stone];

  const actionBtn = s.available
    ? `<a href="${s.productUrl}" class="action_button" target="_blank">Why It Chose You</a>`
    : `<a href="/pages/contact-us" class="action_button">Ask About ${stone}</a>`;

    let optionalInfo = "";
// optionalInfo = `
//   <p><strong>Description:</strong> ${s.description}</p>
//   <p><strong>Why it chooses you:</strong> ${s.why}</p>
//   <p><strong>Element:</strong> ${s.element}</p>
// `;

 resultDiv.innerHTML = `
  <div style="flex: 1 1 50%;">
    <img src="${s.image}" alt="${stone}">
  </div>
  <div style="flex: 2 1 400px;">
    <h2>${userName}, your stone is ${stone}</h2>    
    ${optionalInfo}
    <div style="margin-top: 20px;">
      ${actionBtn}
    </div>

    <div style="margin-top: 12px;">
      <a href="javascript:void(0)" class="action_button link" onclick="resetQuiz()">Start Over</a>
    </div>
  </div>
`;

  document.getElementById("final-step").style.display = "none";
}

function resetQuiz() {
  userAnswers = {};
  userName = "";

  if (grettingDiv) grettingDiv.innerHTML = "";
  const resultDiv = document.getElementById("quiz-result");
  if (resultDiv) resultDiv.innerHTML = "";
document.querySelector(".crystal-quiz-heading").style.display = "block";
document.querySelector(".crystal-quiz-subheading").style.display = "block";
  document.getElementById("step-name").style.display = "block";
  document.getElementById("step-q1").style.display = "none";
  document.getElementById("step-q2").style.display = "none";
  document.getElementById("step-q3").style.display = "none";
  document.getElementById("final-step").style.display = "none";

  document.querySelectorAll(".quiz-options-grid button")
    .forEach(btn => btn.classList.remove("selected"));
}

function calculateTopStone(answers) {
  const score = {};

  for (const [q, a] of Object.entries(answers)) {
    const stones = quizData[q] && quizData[q][a];
    if (!stones) continue;

    stones.forEach(st => {
      score[st] = (score[st] || 0) + 1;
    });
  }

  const max = Math.max(...Object.values(score));
  const top = Object.keys(score).filter(st => score[st] === max);

  return top[Math.floor(Math.random() * top.length)];
}

/* Expose globally */
window.startQuiz = startQuiz;
window.showResult = showResult;
window.resetQuiz = resetQuiz;
